export const SCREENER_QUESTION_TYPES = [
  {
    description: 'Confirm whether respondents recently purchased or remember buying a product.',
    title: 'Confirm Purchase / Purchase Recall',
  },
  {
    description: 'Verify respondent eligibility by consumer profile or decision-making role.',
    title: 'Consumer / Role Verification',
  },
  {
    description: 'Screen respondents by age before they continue into the survey.',
    title: 'Age Screener',
  },
  {
    description: 'Ask respondents to opt in before answering sensitive topic questions.',
    title: 'Sensitive Topic Opt-In',
  },
  {
    description: 'Confirm whether respondents have stopped purchasing within a relevant window.',
    title: 'Lapsed Purchase Verification',
  },
];
